// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventVerificationDigitalCredentials
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.verification.PresentmentRecord
import kotlin.time.Duration
import org.multipaz.verification.toDataItem
import org.multipaz.verification.fromDataItem

fun EventVerificationDigitalCredentials.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "mXSZOPO0b-ZThwwsaYvA_VIO2B1oWApJQgUB9AcUmoM")
val EventVerificationDigitalCredentials_cborSchemaId = ByteString(-103, 116, -103, 56, -13, -76, 111, -26, 83, -121, 12, 44, 105, -117, -64, -3, 82, 14, -40, 29, 104, 88, 10, 73, 66, 5, 1, -12, 7, 20, -102, -125)

fun EventVerificationDigitalCredentials.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "VerificationDigitalCredentials")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentRecord", this.presentmentRecord.toDataItem())
    builder.put("requestJson", Tstr(this.requestJson))
    builder.put("responseJson", Tstr(this.responseJson))
    val durationRequestSentToResponseReceived = this.durationRequestSentToResponseReceived
    if (durationRequestSentToResponseReceived != null) {
        builder.put("durationRequestSentToResponseReceived", Tstr(durationRequestSentToResponseReceived.toIsoString()))
    }
    val origin = this.origin
    if (origin != null) {
        builder.put("origin", Tstr(origin))
    }
    val appId = this.appId
    if (appId != null) {
        builder.put("appId", Tstr(appId))
    }
    return builder.end().build()
}

fun EventVerificationDigitalCredentials_fromDataItem(dataItem: DataItem): EventVerificationDigitalCredentials {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentRecord = PresentmentRecord.fromDataItem(dataItem["presentmentRecord"])
    val requestJson = dataItem["requestJson"].asTstr
    val responseJson = dataItem["responseJson"].asTstr
    val durationRequestSentToResponseReceived0 = if (dataItem.hasKey("durationRequestSentToResponseReceived")) {
        dataItem["durationRequestSentToResponseReceived"].asNullable?.asTstr?.let { Duration.parse(it) }
    } else {
        null
    }
    val origin0 = if (dataItem.hasKey("origin")) {
        dataItem["origin"].asTstr
    } else {
        null
    }
    val appId0 = if (dataItem.hasKey("appId")) {
        dataItem["appId"].asTstr
    } else {
        null
    }
    return EventVerificationDigitalCredentials(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentRecord = presentmentRecord,
        requestJson = requestJson,
        responseJson = responseJson,
        durationRequestSentToResponseReceived = durationRequestSentToResponseReceived0,
        origin = origin0,
        appId = appId0,
    )
}
